
import { Suspense, useEffect } from "react";
import { lazyWithRetry as lazy } from "./lib/lazy-with-retry";
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Index from "./pages/Index";
import { CookieConsentBanner } from "./components/CookieConsentBanner";
import { AuthReturnHandler } from "./components/AuthReturnHandler";
import { InternalAnalyticsTracker } from "./components/InternalAnalyticsTracker";
import { loadGoogleAds } from "./lib/consent";


const About = lazy(() => import("./pages/About"));
const Author = lazy(() => import("./pages/Author"));
const Blog = lazy(() => import("./pages/Blog"));
const BlogPost = lazy(() => import("./components/BlogPost"));
const Privacy = lazy(() => import("./pages/Privacy"));
const Terms = lazy(() => import("./pages/Terms"));
const Disclaimer = lazy(() => import("./pages/Disclaimer"));
const SlimCrystal = lazy(() => import("./pages/SlimCrystal"));
const CrystalWaterBottle = lazy(() => import("./pages/CrystalWaterBottle"));
const FAQPage = lazy(() => import("./pages/FAQ"));
const NotFound = lazy(() => import("./pages/NotFound"));
const SchemaCheck = lazy(() => import("./pages/SchemaCheck"));
const Measurement = lazy(() => import("./pages/Measurement"));


const queryClient = new QueryClient();

const App = () => {
  useEffect(() => {
    void loadGoogleAds();
  }, []);

  return (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <AuthReturnHandler />
        <InternalAnalyticsTracker />
        {/* Skip to main content link for accessibility */}
        <a href="#main-content" className="skip-link">
          Skip to main content
        </a>
        <Suspense fallback={<div className="min-h-screen" />}>
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/about" element={<About />} />
            <Route path="/author" element={<Author />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/disclaimer" element={<Disclaimer />} />
            <Route path="/slimcrystal" element={<SlimCrystal />} />
            <Route path="/crystal-water-bottle" element={<CrystalWaterBottle />} />
            <Route path="/faq" element={<FAQPage />} />
            <Route path="/measurement" element={<Measurement />} />
            {import.meta.env.DEV && (

              <Route path="/schema-check" element={<SchemaCheck />} />
            )}

            {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
      <CookieConsentBanner />

    </TooltipProvider>
  </QueryClientProvider>
  );
};

export default App;
